import styled from "styled-components";

const S = {
    PageWrapper: styled.div`
        background: #f8fafc;
        min-height: 100vh;
        padding-bottom: 80px;
    `,
    HeroSection: styled.section`
        background: linear-gradient(135deg, #00A9C4 0%, #00798c 100%);
        padding: 80px 20px;
        text-align: center;
        color: white;

        .hero-content {
            max-width: 800px;
            margin: 0 auto;

            h1 {
                font-size: 3.5em;
                font-weight: 800;
                margin: 0 0 20px 0;
                letter-spacing: -1px;

                @media (max-width: 768px) {
                    font-size: 2.5em;
                }
            }
        }
    `,
    Breadcrumb: styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 10px;
        font-size: 1.1em;
        opacity: 0.9;
        
        a, span {
            color: white;
            text-decoration: none;
            font-weight: 500;
            transition: opacity 0.2s ease;
            
            &:hover {
                opacity: 0.7;
            }
        }
        
        .separator {
            font-size: 0.9em;
            opacity: 0.6;
        }
    `,
    ContentWrapper: styled.div`
        max-width: 1200px;
        margin: -40px auto 0;
        padding: 0 20px;
        position: relative;
        z-index: 10;
        
        .gallery-container {
            background: white;
            border-radius: 24px;
            padding: 50px;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
            border: 1px solid rgba(0,0,0,0.04);
            margin-bottom: 40px;

            @media (max-width: 768px) {
                padding: 30px 20px;
            }

            .section-header {
                text-align: center;
                margin-bottom: 40px;

                h2 {
                    font-size: 2em;
                    font-weight: 700;
                    color: #1e293b;
                    margin: 0;
                }
            }

            .grid-container {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
                gap: 30px;
                
                @media (max-width: 768px) {
                    grid-template-columns: 1fr;
                }
                
                a {
                    text-decoration: none;
                    display: block;
                }

                .category-card {
                    background: #fff;
                    border-radius: 20px;
                    overflow: hidden;
                    box-shadow: 0 10px 30px rgba(0,0,0,0.05);
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                    border: 1px solid rgba(0,0,0,0.05);
                    height: 100%;
                    display: flex;
                    flex-direction: column;

                    &:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 15px 40px rgba(0,169,196,0.15);
                        border-color: rgba(0,169,196,0.3);
                        
                        .image-wrapper img {
                            transform: scale(1.05);
                        }
                    }

                    .image-wrapper {
                        width: 100%;
                        height: 200px;
                        overflow: hidden;
                        position: relative;
                        background: #f1f5f9;

                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            transition: transform 0.5s ease;
                        }
                    }

                    .card-content {
                        padding: 20px;
                        flex: 1;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        text-align: center;

                        h2 {
                            margin: 0;
                            font-size: 1.5em;
                            font-weight: 600;
                            color: #334155;
                            transition: color 0.3s ease;
                        }
                    }

                    &:hover .card-content h2 {
                        color: #00A9C4;
                    }
                }
            }
        }
    `
};

export default S;